import { FC } from 'react';
import styles from './input.module.scss';

const Input: FC<InputProps> = (props: InputProps) => {
    const { onChange, placeholder, defaultValue, onBlur, style = {} } = props;

    return (
        <input
            className={styles['input-wrapper']}
            type="text"
            defaultValue={defaultValue}
            placeholder={placeholder}
            onChange={e => onChange(e.target.value)}
            onBlur={() => onBlur && onBlur()}
            onClick={_event => _event.stopPropagation()}
            style={style}
        />
    );
};

interface InputProps {
    onChange: (text: string) => void;
    placeholder: string;
    defaultValue?: string;
    onBlur?: Function;
    style?: object;
}

export default Input;
